var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObReorderButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41.91a.833.833 0 011.18 0l4.166 4.167a.833.833 0 11-1.179 1.179L5 2.678 1.423 6.256A.833.833 0 11.244 5.077L4.411.911zM.245 11.745a.833.833 0 011.179 0L5 15.321l3.577-3.577a.833.833 0 011.179 1.178L5.589 17.09a.833.833 0 01-1.178 0L.244 12.923a.833.833 0 010-1.179z",
    fill: "#ED1B2E"
  })));
}

export default SvgObReorderButton;